import type { ReactNode } from "react";

type SettingRowProps = {
	title: string;
	description?: string;
	/** Render the control below the text instead of beside it */
	stacked?: boolean;
	children: ReactNode;
};

export function SettingRow({ title, description, stacked, children }: SettingRowProps) {
	if (stacked) {
		return (
			<div className="flex flex-col gap-3 px-2 py-4 border-b border-border/40">
				<div>
					<p className="text-sm font-medium">{title}</p>
					{description && (
						<p className="text-sm text-muted-foreground">{description}</p>
					)}
				</div>
				<div>{children}</div>
			</div>
		);
	}

	return (
		<div className="flex items-center justify-between gap-4 px-2 py-4 border-b border-border/40">
			<div className="min-w-0 flex-1">
				<p className="text-sm font-medium">{title}</p>
				{description && (
					<p className="text-sm text-muted-foreground">{description}</p>
				)}
			</div>
			<div className="shrink-0">{children}</div>
		</div>
	);
}
